// extracted by mini-css-extract-plugin
export default {"card":"styles_card__t-OP5","storeButtonsRow":"styles_storeButtonsRow__og14U","onboardingPage":"styles_onboardingPage__s5iLI"};